import React from "react";
import ReactApexChart from "react-apexcharts";
import { lineChartData, lineChartOptions } from "variables/charts";

// Renders an area/line chart. When `series` / `options` props are supplied
// (e.g. the API-driven Sales Overview) they take precedence; otherwise it
// falls back to the static demo data so existing callers keep working.
class LineChart extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      chartData: [],
      chartOptions: {},
    };
  }

  componentDidMount() {
    this.setState({
      chartData: this.props.series || lineChartData || [],
      chartOptions: this.props.options || lineChartOptions || {},
    });
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.series !== this.props.series ||
      prevProps.options !== this.props.options
    ) {
      this.setState({
        chartData: this.props.series || lineChartData || [],
        chartOptions: this.props.options || lineChartOptions || {},
      });
    }
  }

  render() {
    return (
      <ReactApexChart
        options={this.state?.chartOptions || null}
        series={this.state?.chartData || []}
        type="area"
        width="100%"
        height="100%"
      />
    );
  }
}

export default LineChart;
